import GeneralModel from './GeneralModel';
import mainAPI from "../api/MainAPI";
import objUtils from "../utils/objUtils";

export default class DrugBoxModel extends GeneralModel {
	constructor(socket) {
		super('drug_box', socket, async ()  => await mainAPI.drug_box.all({archived: true}) );
	}

	async archive(drug_box_id, notes) {
		const result = await super.archive(drug_box_id, notes)
		const {reason} = result;
		if(reason === 'UNRESOLVED_DEPENDENCY') {
			return {...result, reason: 'ASSOCIATED_DRUGS'};
		}
		return result;
	};
}



// WEBPACK FOOTER //
// ./src/model/DrugBoxModel.js